import { convertBrowserLocaleToLanguageRegion } from "@storytell/cp-client";
import { createMemo } from "solid-js";
import { useI18n } from "~/i18n/context";

/**
 * Hook that returns the current language region based on the i18n context
 * @returns A memoized LanguageRegion value
 */
export function useLanguageRegion() {
  const { currentLanguage } = useI18n();

  return createMemo(() => {
    // Convert the current language to LanguageRegion using cp-client's utility
    return convertBrowserLocaleToLanguageRegion(currentLanguage());
  });
}
